module.exports = __webpack_public_path__ + "static/media/logoTableSpade.eab70640.svg";